// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"506e012d","87":"594406fb","135":"6c2bf372","173":"db00e3ff","248":"a188cb85","453":"c3db55c9","468":"9447ca7c","482":"ada316d0","488":"8f4240b4","750":"c2d30349","843":"ac5b624a","863":"57a81c60","938":"8ff92455"}[chunkId] + ".chunk.js";
};